import React, {useState} from 'react';
import {Modal, PrimaryButton, SecondaryButton} from '../../components';
import {closeModal} from '../../assets/images/images';
import * as Actions from '../../store/actions';
import {connect} from 'react-redux';
import {encryptData} from '../../helpers/encryptData';

function RevealKeyModal({
  auth: {loading},
  open,
  setOpen,
  setRevealKey,
  viewSecret,
}) {
  const [password, setPassword] = useState('');

  const handleSubmit = async e => {
    e.preventDefault();

    if (password) {
      const encryptedLoginData = encryptData(
        JSON.stringify({
          password,
        }),
      );
      await viewSecret({payload: encryptedLoginData}, () => {
        setRevealKey(true);
        setOpen(false);
      });
    }
  };

  return (
    <Modal
      show={open}
      onClose={setOpen}
      extraModalClasses="max-w-[528px] overflow-y-auto h-fit max-h-[95%] sm:max-h-full rounded-b-none sm:rounded-b-lg absolute bottom-0 sm:relative lookup-modal"
      modalPosition="justify-center sm:justify-end"
      modalTitle="Please confirm password to continue"
    >
      <form onSubmit={handleSubmit} className="text-left">
        <div className="px-6">
          <label htmlFor="dwa" className="mt-6">
            <span className="text-sm ">Confirm password</span>
            <input
              onChange={e => setPassword(e.target.value)}
              type="password"
              id="dwa"
              className="mt-2"
            />
          </label>
        </div>

        <div className="w-full mt-6 px-6 py-[14px] border-[0.5px] flex gap-4 border-transparent border-t-[#EFEFEF]">
          <SecondaryButton
            className="w-[50%] !h-10"
            buttonText="Cancel"
            onClick={() => setOpen(false)}
          />

          <PrimaryButton
            type="submit"
            loading={loading}
            buttonText="Confirm password"
            className="w-[50%] !h-10"
          />
        </div>
      </form>
    </Modal>
  );
}

export default connect(state => state, Actions)(RevealKeyModal);
